import { COUNTRIES } from '@moda/portal-stanchions';

export const useCountryCodeAndCurrency = (inputCountry: string | undefined) => {
  const destinationCountry = COUNTRIES.find(country => country.name === inputCountry);

  const updatedCountryCode = destinationCountry?.alpha2Code;
  const updatedCurrency = destinationCountry?.currencyCode;

  return { updatedCountryCode, updatedCurrency };
};
